module.exports = __webpack_public_path__ + "img/IMG_20200801_203344.50f37cdb.jpg";